import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=0d2d0d46&scoped=true"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"
import style0 from "./Aside.vue?vue&type=style&index=0&id=0d2d0d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../AppData/Roaming/npm/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2d0d46",
  null
  
)

export default component.exports